module.exports = __webpack_public_path__ + "images/emoji/point_up_2.020af753116d2dd0537f.png";